/**
* this is the menu X
*/

document.addEventListener('DOMContentLoaded', () => {
  const productTrigger = document.querySelector('[data-mega-menu-trigger]');
  const megaMenu = document.querySelector('[data-mega-menu]');
  const megaMenuClose = document.querySelector('[data-mega-menu-close]');

  if (!productTrigger || !megaMenu || !megaMenuClose) return;

  productTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    megaMenu.classList.add('mega-menu--open');
  });

  megaMenuClose.addEventListener('click', (e) => {
    e.preventDefault();
    megaMenu.classList.remove('mega-menu--open');
  });
});


/**
* load more instead pagination
*/



